import { Box } from "@mui/material";
import { ReactNode } from "react";

interface PageLayoutMobileProps {
  header?: ReactNode;
  content: ReactNode;
  footer?: ReactNode;
}

/**
 * Mobile page layout component.
 *
 * Simpler layout for mobile devices with full-width sections.
 */
export function PageLayoutMobile({ header, content, footer }: PageLayoutMobileProps) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {header && <Box sx={{ mb: 2 }}>{header}</Box>}

      <Box sx={{ flexGrow: 1, overflow: "auto" }}>{content}</Box>

      {footer && <Box sx={{ mt: 2 }}>{footer}</Box>}
    </Box>
  );
}
